




import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'


import LocalStorageService from '../../../services/LocalStorageService'
import NotificationService from '../../../services/NotificationService'
import UserTagService from '../../../services/UserTagService'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'
import FontAwesome from '../../../components/compound/fontAwesome/FontAwesome'
import Form from '../../../components/simple/form/Form'
import FormField from '../../../components/simple/formField/FormField'
import H4 from '../../../components/simple/heading/H4.js'
import Text from '../../../components/simple/text/Text'
import DataTable from '../../../components/simple/dataTable/DataTable'
import TextInput from '../../../components/simple/input/TextInput'

import ActionButton from '../../../components/compound/actionButton/ActionButton.js'
import Anchor from '../../../components/simple/anchor/Anchor.js'
import PulseLoader from 'react-spinners/PulseLoader.js'

function KeyContacts (props) {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)

    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const params = useParams()
    const userId = params.userid

    const [contactDetails, setContactDetails] = useState({
        firstName: '',
        lastName: '',
        role: '',
        email: '',
        phone: ''
    })
    const [contacts, setContacts] = useState([])
    const [contactAddButton, setContactAddButton] = useState(false)
    const [mappedContacts, setMappedContacts] = useState([])
    const [contactColumns, setContactDataColumns] = useState()

      const removeContact = (data) => {
        const newContacts = contacts.filter((item) => item.email !== data.email )
    
        setContacts(newContacts)
        submitContacts(newContacts)
      }

    const submitContacts = async (values) => {

        const data = [
        {
            key: 'keycontacts',
            organisation: activeOrg.id,
            type: 'keycontacts',
            user: userId,
            value: JSON.stringify(values)
        }
        ]

        const tagSet = await UserTagService.set(apiToken, data)
        if (tagSet.error) {
        NotificationService.error(tagSet.error)
        } else {
        NotificationService.success('Key Contacts added')
        getContacts()
        }
    }

    const getContacts = async () => {
    const params = {
      fields: 'user,type,key,organisation,value'
    }

    const where = {
      user: userId
    }

    let contacts = await UserTagService.get(apiToken, params, where)

    // Filter out the 'keycontacts'
    if (contacts) {
      contacts = contacts.filter((item) => item.key === 'keycontacts')

      var parsedContacts
      try {
        parsedContacts = JSON.parse(contacts[0].value)
      } catch (err) {
        console.error(err)
      }

      if (parsedContacts) {
        setContacts(parsedContacts)
      }
    }
  }


    const addContact = async () => {
      const contact = {
        firstName: contactDetails.firstName,
        lastName: contactDetails.lastName,
        role: contactDetails.role,
        email: contactDetails.email,
        phone: contactDetails.phone
      }

      let savedContacts = [...contacts, contact]

      setContacts(savedContacts)


      await submitContacts(savedContacts)

      // Re-initialise input fields
      setContactDetails({
        firstName: '',
        lastName: '',
        role: '',
        email: '',
        phone: ''
      })
      setContactAddButton(false)

      

    }

    const goBack = () => {
        navigate(-1)
    }     

    useEffect(() => {
        (async () => {
            if (!userId) { return }
            
            setLoading(true)
            await getContacts()
            setLoading(false)
    
            // setClickerValues(previousValues => ({
            // ...previousValues,
            // student: userId
            // }))

        })()
    }, [userId])


    // Contacts have been altered
  // so rebuild the display list
  useEffect(() => {
    setContactDataColumns([
      {
        property: 'firstName',
        header: <Text pad='none' margin='none' color='secondary' weight='800'>First Name</Text>,
        render: datum => <Text size='medium'>{datum.firstName}</Text>

      },
      {
        property: 'lastName',
        header: <Text pad='none' margin='none' color='secondary' weight='800'>Last Name</Text>,
        render: datum => <Text size='medium'>{datum.lastName}</Text>

      },
      {
        property: 'role',
        header: <Text pad='none' margin='none' color='secondary' weight='800'>Role</Text>,
        size: 'xsmall',
        render: datum => <Text size='medium'>{datum.role}</Text>

      },
      {
        property: 'email',
        header: <Text pad='none' margin='none' color='secondary' weight='800'>Email</Text>,
        size: 'small',
        render: datum => (
          <Anchor href={`mailto:${datum.email}`} color='primary'>{datum.email}</Anchor>
        )

      },
      {
        property: 'phone',
        header: <Text pad='none' margin='none' color='secondary' weight='800'>Phone</Text>,
        render: datum => <Text size='medium'>{datum.phone}</Text>
      },
      {
        property: 'actions',
        render: datum => (
          <Box direction='row'>
            <ActionButton label={<Text><FontAwesome icon={['fal', 'minus-circle']} /></Text>} margin={{ horizontal: 'xsmall' }} onClick={() => removeContact(datum)} target='_self' />
          </Box>
        )
      }
    ])

    if (contacts) {
      const mappedContacts = contacts.map((contact, index) => ({
        reference: contact.reference,
        dob: contact.dob,
        firstName: contact.firstName,
        lastName: contact.lastName,
        role: contact.role,
        email: contact.email,
        phone: contact.phone
      }))

      setMappedContacts(mappedContacts)
    }
  }, [contacts, userId])


  if (loading) {
    return <Box direction='row' gap='medium' >
      <Box background='white' direction='column' gap='small' margin={{ top: 'small', bottom: 'large' }} border={{ color: 'light-4', side: 'right' }} pad='medium' flex='grow'>
        <PulseLoader color='#ff8300' size={15} margin={5} />
      </Box>
    </Box>
  }

  return (
    <Box gridArea='main' background='white' direction='column' gap='small' round='small' margin={{ bottom: 'large' }}>

      <Box
        gap='small'
        round='small'
        margin={{ top: 'medium', bottom: 'medium', horizontal: 'small' }}
      >

        {!loading && <>
            <Form
                      onChange={nextValue => {
                        // Enable Contact Add button if all fields have data
                        setContactAddButton(nextValue.firstName !== '' && nextValue.lastName !== '' && nextValue.email !== '')
                        setContactDetails(nextValue)
                      }}
                      onSubmit={({ value: nextValue }) => {
                        submitContacts(nextValue)
                      }}
                      value={contactDetails}
                    >
                      
                      <H4 color='secondary' margin={{ top: 'none', bottom: 'small' }}>Current Key Contacts</H4>
            
                      {mappedContacts.length > 0 &&
                        <Box direction='row-responsive' gap='medium'>
                          <DataTable
                            columns={contactColumns}
                            data={mappedContacts}
                            fill='horizontal'
                            size='large'
                          />
                        </Box>}
                <Divider color='#eee' margin={{ top: 'medium', bottom: 'medium' }} />

                    <H4 color='secondary' margin={{ top: 'none', bottom: 'small' }}>Add New Key Contact</H4>

            
                      <Box direction='row-responsive' gap='small'>
                        <FormField
                          label='First Name'
                          name='firstName'
                        >
                          <TextInput
                            name='firstName'
                            type='text'
                          />
                        </FormField>
            
                        <FormField
                          label='Last Name'
                          name='lastName'
                        >
                          <TextInput
                            name='lastName'
                            type='text'
                          />
                        </FormField>
            
                        <FormField
                          label='Role'
                          name='role'
                        >
                          <TextInput
                            name='role'
                            type='text'
                          />
                        </FormField>
            
                        <FormField
                          label='Email'
                          name='email'
                        >
                          <TextInput
                            name='email'
                            type='email'
                          />
                        </FormField>
            
                        <FormField
                          label='Phone'
                          name='phone'
                        >
                          <TextInput
                            name='phone'
                            type='phone'
                          />
                        </FormField>
            
                      </Box>
                      <ActionButton disabled={!contactAddButton} label='Add'  onClick={() => addContact()} alignSelf='end' />

                      {/* <Divider color='primary' margin={{ top: 'medium', bottom: 'none' }} />
                      <Box direction='row' justify='between' margin={{ top: 'medium' }}>
                        <ActionButton label='< Back' onClick={() => goBack()} secondary />
                        <ActionButton type='submit' label='Save' primary />
                      </Box> */}
                    </Form>
        </>}
        {loading && <Text>Loading...</Text>}
      </Box>
    </Box>
  )
}
export default KeyContacts
